import { membershipContentStore } from "../../../common/redux/membershipContent";

const progressStepNameHelper = (statePlaceholder: string) => {
  const memberShipContent = membershipContentStore.getState();
  switch (statePlaceholder) {
    case "Production":
      return memberShipContent.productionStep.stepName;

    case "Getting Started":
      return memberShipContent.gettingStartedStep.stepName;

    case "Membership Type":
      return memberShipContent.membershipTypeStep.stepName;

    case "Review":
      return memberShipContent.reviewStep.stepName;

    case "Welcome":
      return memberShipContent.greetingStep.stepName;

    default:
      return "...";
  }
};

export default progressStepNameHelper;
